import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getIcd10(text: string): Promise<{ icd10s: string[] }> {
    const url = this.common.constructPath('/predict/nlp/icd10');
    return await this.common.postJSON(url, { text });
  }
}
